module.exports = __webpack_public_path__ + "77d51180a9b43de60f4b43b50a30b4e3.svg";